export class AccordionNav {
  constructor(el) {
    if (!el) return;
    this.el = el;
    this.trigger = document.querySelector('.js-nav-toggle');
    this.items = Array.from(el.querySelectorAll('.js-nav-item'));
    this.bindEvents();
  }

  bindEvents() {
    this.trigger?.addEventListener('click', e => { e.stopPropagation(); this.toggleNavMenu(); });
    // Delegated handler — catches toggles on any nesting level. Nested items get
    // `js-nav-item` but not `js-has-submenu`, so we cannot bind per-item; we walk
    // up from the click target with closest() to find the nearest item.
    this.el.addEventListener('click', e => {
      const toggle = e.target.closest('.js-collapse-toggle');
      if (!toggle || !this.el.contains(toggle)) return;
      const item = toggle.closest('.js-nav-item');
      if (!item) return;
      e.stopPropagation();
      this.toggleCollapsingMenu(item);
    });
  }

  toggleNavMenu() {
    document.body.classList.toggle('is-off-canvas');
  }

  toggleCollapsingMenu(item) {
    const submenu = item.querySelector('.js-submenu');
    if (!submenu) return;

    if (item.classList.contains('is-open')) {
      submenu.style.height = submenu.scrollHeight + 'px';
      submenu.offsetHeight; // force reflow so browser commits the explicit height before transition
      submenu.style.transition = 'height 300ms ease';
      submenu.style.height = '0';
      submenu.addEventListener('transitionend', () => {
        // Collapse complete: drop back to CSS default (display: none) and clear animation props.
        submenu.style.cssText = 'display: none;';
      }, { once: true });
    } else {
      submenu.style.display = 'block';
      submenu.style.overflow = 'hidden';
      submenu.style.height = '0';
      const targetHeight = submenu.scrollHeight + 'px';
      submenu.offsetHeight; // force reflow so height:0 is committed before transition starts
      submenu.style.transition = 'height 300ms ease';
      submenu.style.height = targetHeight;
      submenu.addEventListener('transitionend', () => {
        // Keep display:block so the panel stays open after the height animation ends;
        // the CSS default of display:none would otherwise snap it shut.
        submenu.style.cssText = 'display: block;';
      }, { once: true });
    }

    item.classList.toggle('is-open');
  }
}
